import { TemplateDetailsDto, TemplateImagesDto } from "@domain/project/template";
import { TemplateProductListDto } from "@domain/project/template/property/project/productList/template-product-list.dto";
import { Type } from "class-transformer";
import { IsArray, IsOptional, IsString, ValidateNested } from "class-validator";
import { TemplateFloorplansDto } from "./floorplans/templates-floorplans.dto";

export class TemplateProjectDto {
  @IsOptional()
  @ValidateNested()
  @Type(() => TemplateProductListDto)
  productList?: TemplateProductListDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => TemplateDetailsDto)
  details?: TemplateDetailsDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => TemplateImagesDto)
  images?: TemplateImagesDto;

  @IsOptional()
  @ValidateNested()
  @Type(() => TemplateFloorplansDto)
  floorplans?: TemplateFloorplansDto;

  @IsOptional()
  @IsArray()
  @IsString({ each: true })
  regions?: string[];
}
